import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '@/components/organisms/forms/form';

export default function InterestsHoldForm({ form, validateEndDate, t }) {
    return (
        <Form {...form}>
            <form className="flex flex-col gap-secondDegree p-thirdDegree" onSubmit={(e) => e.preventDefault()}>
                <FormField
                    control={form.control}
                    name="startDate"
                    rules={{ required: t('consultants.statement.interestsHolds.startDateRequired') }}
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel fontWeight="bold" message="consultants.statement.interestsHolds.startDate" />
                            <FormControl>
                                <Input type="date" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="endDate"
                    rules={{ validate: validateEndDate }}
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel fontWeight="bold" message="consultants.statement.interestsHolds.endDate" />
                            <FormControl>
                                <Input type="date" min={form.watch('startDate') || undefined} {...field} />
                            </FormControl>
                            <FormDescription size="small" message="consultants.statement.interestsHolds.endDateHelp" />
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="comment"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel fontWeight="bold" message="consultants.statement.interestsHolds.comment" />
                            <FormControl>
                                <Textarea {...field} />
                            </FormControl>
                        </FormItem>
                    )}
                />
            </form>
        </Form>
    );
}
